<template>
  <v-list-item @click="detail(customer)" :key="customer.KundenNr">

      <v-list-item-title>
        <span>
          {{ customer.Kundname }}
        </span>
      </v-list-item-title>
      <v-list-item-subtitle v-if="customer.PostAnschrift">
        <span>
          {{`${customer.PostAnschrift[0]?.Plz ?? ''} ${customer.PostAnschrift[0]?.Ort ?? ''}`}}
        </span>
      </v-list-item-subtitle>

    <template #append>
      <v-list-item-action>
        <div>
          <v-chip variant="outlined" :color="customer.color">
            <v-icon class="mr-1">{{ customer.icon }}</v-icon> <strong>{{ customer.GroupName }}</strong>
          </v-chip>
        </div>
      </v-list-item-action>
    </template>
  </v-list-item>
</template>

<script setup lang="ts">
import Provider from '@/model/Provider';
import {useRouter} from 'vue-router';

const router = useRouter();

defineProps({
  customer: {
    type: Provider,
    required: true,
  },
});

function detail(provider: Provider) {
  router.push({name: 'customer_details', params: {id: provider.KundenNr.toString()}});
};

defineExpose({
  detail,
});
</script>

